import QrScanStyles from 'shared/style/qrScanStyles'

const QrScannerInstructions = ({
	instructions,
	title = '스캔 지침',
	showTitle = true,
}) => {
	return (
		<QrScanStyles.InstructionsContainer>
			{showTitle && (
				<QrScanStyles.SectionTitle>{title}</QrScanStyles.SectionTitle>
			)}

			{showTitle ? (
				<QrScanStyles.InstructionsList>
					{instructions.map((instruction, index) => (
						<QrScanStyles.InstructionItem key={index}>
							{instruction}
						</QrScanStyles.InstructionItem>
					))}
				</QrScanStyles.InstructionsList>
			) : (
				<QrScanStyles.InstructionsCenterList>
					{instructions.map((instruction, index) => (
						<QrScanStyles.InstructionItemCenter key={index}>
							{instruction}
						</QrScanStyles.InstructionItemCenter>
					))}
				</QrScanStyles.InstructionsCenterList>
			)}
		</QrScanStyles.InstructionsContainer>
	)
}

export default QrScannerInstructions
